var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-pm-dataQuery-tree"},[_c('ejs-treeview',{ref:"measureTreeForNoRealQuery",attrs:{"fields":_vm.fields,"nodeSelected":_vm.nodeSelectedOfMeasureTreeForNoRealQuery}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }